import { Link } from "@tanstack/react-router";
import privacy from "../../../../docs/legal/privacy-policy.md?raw";
import terms from "../../../../docs/legal/terms-of-use.md?raw";
import { Markdown } from "../legal/Markdown";

/**
 * Public legal pages, linked from the app and the store listings. They show the approved documents in
 * docs/legal as they stand.
 */
function LegalPage({ source }: { source: string }) {
  return (
    <main className="public">
      <div className="public-card legal-card">
        <div className="logo">
          <img src="/logo-dark.png" alt="مُبين" />
        </div>
        <article className="card section">
          <Markdown source={source} />
        </article>
        <div className="org-footer">
          <span className="muted small">تابع لـ</span>
          <img src="/org/horizontal-color.png" alt="الجمعية الخيرية لتحفيظ القرآن الكريم بمحافظة رماح" />
        </div>
        <nav className="legal-links small">
          <Link to="/privacy">سياسة الخصوصية</Link>
          <Link to="/terms">شروط الاستخدام</Link>
          <Link to="/account-deletion">طلب حذف الحساب</Link>
        </nav>
      </div>
    </main>
  );
}

export const PrivacyPage = () => <LegalPage source={privacy} />;
export const TermsPage = () => <LegalPage source={terms} />;
